import React, { useState, useEffect } from "react";
import SideBar from "../components/SideBar";
import TopBar from "../components/TopBar";
import donatemockup from "../assets/image/donatemockup.webp";
import greenheart from "../assets/image/handsvg.svg";

function Donate() {
  const [frequency, setFrequency] = useState("One-Time");
  const [amount, setAmount] = useState("");
  const [selectedAmount, setSelectedAmount] = useState(null);
  const [showBankDetails, setShowBankDetails] = useState(false);
  const TEST_BASE_URL = process.env.REACT_APP_BASE_URL;

  useEffect(() => {
    const fetchDonationStatus = async () => {
      try {
        const token = localStorage.getItem("authToken");

        const res = await fetch(`${TEST_BASE_URL}/donation-status`, {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        });

        if (!res.ok) {
          throw new Error("Failed to fetch donation status");
        }

        const data = await res.json();
        setShowBankDetails(data.data[0]?.is_donation_enabled);
      } catch (err) {
        console.error(err.message);
      }
    };

    fetchDonationStatus();
  }, [TEST_BASE_URL]);

  const presetAmounts = [10, 20, 30, 100];

  const handleAmountClick = (value) => {
    setSelectedAmount(value);
    setAmount(value);
  };

  const [sidebarOpen, setSidebarOpen] = useState(false);

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  return (
    <>
      <section className="dashboard">
        <SideBar isOpen={sidebarOpen} />
        <div className="body-content">
          <TopBar onToggleSidebar={toggleSidebar} />
          <div className="bottom-content">
            <div className="prayer-title">
              <span>Online Donations & Giving</span>
              <a href="/donatehistory">
                <small>
                  <u>Donation History</u>
                </small>
              </a>
            </div>
            <div className="burdens-card">
              <div className="row burdenrow">
                <div className="col-md-5 px-3">
                  <h5 className="burdens-card-head">
                    Give with a Cheerful Heart
                  </h5>
                  <p>
                    Every gift you sow helps advance the mission of the church —
                    supporting worship services, outreach programmes, community
                    care, youth development, missions, and more. Thank you for
                    partnering with us to spread God's love.
                  </p>

                  <img src={donatemockup} alt="" width="100%" />
                  <div className="feedback-note">
                    <h6>Why Give?</h6>
                    <ul>
                      <li>To honour God with our resources</li>
                      <li>To support the work of ministry</li>
                      <li>To be a blessing to others</li>
                      <li>To invest in Kingdom impact</li>
                    </ul>
                  </div>
                </div>
                <div className="col-md-6">
                  {!showBankDetails ? (
                    <div
                      className="bank-details-card p-4 shadow-sm rounded"
                      style={{
                        background: "#f8fff8",
                        border: "1px solid #d7f5d7",
                      }}
                    >
                      <h5
                        className="mb-5"
                        style={{ color: "#0a7d00", fontWeight: "700" }}
                      >
                        Bank Transfer Details
                      </h5>

                      <p className="mb-2">
                        <strong>Bank Name:</strong> Bank Of America
                      </p>
                      <p className="mb-2">
                        <strong>Account Name:</strong> RCCG New Beginning
                        Chapel.
                      </p>
                      <p className="mb-2">
                        <strong>Account Number:</strong>{" "}
                        <span style={{ fontSize: "18px", fontWeight: "700" }}>
                          0123456789
                        </span>
                      </p>
                      <p className="mb-3">
                        <strong>Sort Code:</strong> 00-00-00
                      </p>

                      <div
                        className="p-3 mt-5 rounded"
                        style={{
                          background: "#eaffea",
                          border: "1px dashed #9ddf9d",
                        }}
                      >
                        <p className="m-0 text-success">
                          <strong>
                            Please make your donation via bank transfer.
                          </strong>
                        </p>
                      </div>

                      <p className="mt-3 text-muted">
                        Once you make a transfer, kindly keep your transaction
                        reference for confirmation.
                      </p>
                    </div>
                  ) : (
                    <div className="donationcard">
                      <h6>Select Gift Frequency</h6>
                      <div className="donationtab">
                        <span
                          className={frequency === "One-Time" ? "active" : ""}
                          onClick={() => setFrequency("One-Time")}
                        >
                          One-Time
                        </span>
                        <span
                          className={frequency === "Monthly" ? "active" : ""}
                          onClick={() => setFrequency("Monthly")}
                        >
                          Monthly
                        </span>
                      </div>

                      <h6>Input or select an amount you want to donate</h6>
                      <form className="donationform">
                        <label>Input Amount</label>
                        <input
                          type="tel"
                          className="form-control"
                          placeholder="Enter an amount (£)"
                          value={amount}
                          onChange={(e) => {
                            setAmount(e.target.value);
                            setSelectedAmount(null);
                          }}
                        />

                        <div className="donationprice">
                          {presetAmounts.map((value) => (
                            <span
                              key={value}
                              className={
                                selectedAmount === value ? "active" : ""
                              }
                              onClick={() => handleAmountClick(value)}
                            >
                              £ {value}
                            </span>
                          ))}
                        </div>

                        <label>Name</label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter your name"
                        />

                        <label className="pt-4">Email</label>
                        <input
                          type="email"
                          className="form-control emaildown"
                          placeholder="Enter your email"
                        />

                        <p>
                          <small>
                            Please read our{" "}
                            <a
                              href="https://www.rccgbournemouth.org/privacy-notice"
                              target="_blank"
                              rel="noopener noreferrer"
                              className="privacy-link"
                            >
                              <u>Privacy Notice</u>
                            </a>{" "}
                            to learn how we protect your personal data.
                          </small>
                        </p>

                        <div className="donate_button">
                          <button className="donatebutton">Donate Now</button>
                        </div>
                      </form>
                    </div>
                  )}

                  <div className="feedback_note mx-2">
                    <h6>Why Give?</h6>
                    <div>
                      <li>To honour God with our resources</li>
                      <li>To support the work of ministry</li>
                      <li>To be a blessing to others</li>
                      <li>To invest in Kingdom impact</li>
                    </div>
                  </div>
                </div>

                <div className="mb-3 mt-4">
                  <hr />
                </div>
                <div className="greenheart">
                  <img src={greenheart} alt="" width="70px" />
                  <div>
                    <h6>Thank You for Your Generosity</h6>
                    <span>
                      <small>
                        We are grateful for your faithful giving. May God
                        multiply every seed you sow and bless you richly.
                      </small>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Donate;